import { FC } from "react";
import ForecastCalendar from "../../components/calendar/forecastCalendar";
import ViewHeader from "../../components/viewHeader/viewHeader";
import { LineChartSolid2Filled } from "@tag/tag-icons";
import { useForecastContext } from "../../context/forecastContext";
import ForecastMixFilters from "../../components/forecastMixFilters/forecastMixFilters";
import { PeriodTypes } from "../../constants/periodTypes";
import { upperCaseFirstLetter } from "../../utilities/stringHelpers";
import SubmitForecastModal from "../../components/submitForecastModal/submitForecastModal";
import { useUser } from "../../context/userProvider";

const Forecast: FC = () => {
  const {
    forecastState,
    modalVisible,
    onDateChange,
    onMonthChange,
    onPeriodChange,
    onSiteChange,
    setModalVisible,
  } = useForecastContext();

  const { currentUser } = useUser();

  return (
    <>
      <ViewHeader
        icon={<LineChartSolid2Filled size="medium" accent="teal" />}
        title={`Forecasting \\ ${upperCaseFirstLetter(
          PeriodTypes[forecastState.periodType]
        )} \\ ${forecastState.selectedSite?.siteName}`}
        filters={
          <ForecastMixFilters
            sites={currentUser!.siteAccess}
            selectedSite={forecastState.selectedSite?.siteId}
            periodType={forecastState.periodType}
            currentDate={forecastState.selectedDate}
            onDateChange={onDateChange}
            onMonthChange={onMonthChange}
            onPeriodChange={onPeriodChange}
            onSiteChange={onSiteChange}
          />
        }
      />
      <ForecastCalendar />
      <SubmitForecastModal
        visible={modalVisible}
        setVisible={setModalVisible}
      />
    </>
  );
};

export default Forecast;
